import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
// Types
import { AuctionStatus } from 'api/graphql-global-types';
// Helpers
import { getTimeRemaining } from 'helpers/streams';
// Ui
import Text from 'ui3/Text/Text';
// Styles
import styles from './AuctionCountdown.module.scss';

type AuctionCountdownProps = {
  date: string;
  status: AuctionStatus | null;
};

const AuctionCountdown = ({ date, status }: AuctionCountdownProps) => {
  const [, setTimer] = useState<string>(date);

  const countDownDate = dayjs(date).diff(dayjs(), 'millisecond');

  const { days, hours, minutes } = getTimeRemaining(countDownDate);

  const remainingDays = days >= 0 ? `${days}`.padStart(2, '00') : '00';
  const remainingHours = hours >= 0 ? `${hours}`.padStart(2, '00') : '00';
  const remainingMinutes = minutes >= 0 ? `${minutes}`.padStart(2, '00') : '00';

  const isAuctionScheduled = status === AuctionStatus.Scheduled;
  const isAuctionLive = status === AuctionStatus.Live;
  const isAuctionFinished = status === AuctionStatus.Finished;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimer(new Date().toString());
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className={styles.root}>
      <Text variant="subtitle2">
        {isAuctionScheduled && 'Auction Starting in:'}
        {isAuctionLive && 'Auction Ending in:'}
        {isAuctionFinished && 'Auction Ended'}
      </Text>
      {!isAuctionFinished && (
        <Text variant="h6" color="accent-default">
          {`${remainingDays}d ${remainingHours}h ${remainingMinutes}m`}
        </Text>
      )}
    </div>
  );
};

export default AuctionCountdown;
